module.exports = __webpack_public_path__ + "img/todo_completed.7b7296ee.svg";